import { all } from 'redux-saga/effects'
import {
  hierarchyUploadWatcherSaga,
  hierarchyListWatcherSaga,
} from './hierarchy/'
import user from './user'
import courses from './courses'
import {
  lmsProfilesListWatcherSaga,
  lmsProfilesUploadWatcherSaga,
} from './lmsProfiles/'
import { lmsProfilesCreateWatcherSaga } from './lmsProfiles/'
import { lmsProfilesEditProfileWatcherSaga } from './lmsProfiles/'
import { lmsProfilesDeleteProfileWatcherSaga } from './lmsProfiles/'
import { participantsListWatcherSaga } from './participants/list.sagas'
import { participantsDestroyWatcherSaga } from './participants/delete.sagas'
import { createLessonWatcherSaga } from './lessons/create.saga'
import { editLessonOrderWatcherSaga } from './lessons/editLessonOrder.saga'
import { editLessonWatcherSaga } from './lessons/edit'
import { destroyLessonWatcherSaga } from './lessons/destroy.saga'
import {
  enrolCreateWatcherSaga,
  enrolAdminListWatcherSaga,
  enrolAdminEditWatcherSaga,
} from './enrols/'
import { enrolListWatcherSaga } from './enrols/'
import {
  editEnrolWatcherSaga,
  editSynchronousCourseEnrolWatcherSaga,
  enrolCreateManuallyWatcherSaga,
} from './enrols'
import { getLessonWatcherSaga } from './lessons/get.saga'
import { getNextLessonWatcherSaga } from './lessons/nextLesson.saga'
import { getLmsLessonWatcherSaga } from './lessons/getLesson.saga'
import {
  answerLikertCreateWatcherSaga,
  answerTaskCreateWatcherSaga,
  destroyTaskAnswerWatcherSaga,
} from './answers/'
import { answerLikertEditWatcherSaga } from './answers/'
import { answerOpenEnderCreateWatcherSaga } from './answers/'
import { questionTypesListWatcherSaga } from './questionTypes/list.sagas'
import { blockListWatcherSaga } from './blocks/list.saga'
import { createSurveyWatcherSaga } from './blocks/survey/createSurveyBlock.saga'
import { destroySurveyWatcherSaga } from './blocks/survey/destroySurveyBlock.saga'
import { editBlockSurveyWatcherSaga } from './blocks/survey/editSurveyBlock.saga'
import { createLikertWatcherSaga } from './blocks/questions/CreateLikert,saga'
import { questionListWatcherSaga } from './blocks/questions/List.saga'
import { createOpenEndedtWatcherSaga } from './blocks/questions/CreateOpenEnded.saga'
import { questionGetWatcherSaga } from './blocks/questions/Get.saga'
import { questionDestroyLikertWatcherSaga } from './blocks/questions/DestroyLikert.saga'
import { questionDestroyOpenEndedWatcherSaga } from './blocks/questions/DestroyOpenEnded.saga'
import { createRichTextWatcherSaga } from './blocks/richtext/createRichTextBlock.saga'
import { editRichTextBlockWatcherSaga } from './blocks/richtext/editRichTextBlock.saga'
import { destroyRichTextWatcherSaga } from './blocks/richtext/destroyRichTextBlock.saga'
import { editLikertWatcherSaga } from './blocks/questions/EditLikert.saga'
import { editOpenEndedWatcherSaga } from './blocks/questions/EditOpenEnded.saga'
import { editBlocksOrderWatcherSaga } from './blocks/editBlocksOrder.saga'
import monitoring from './monitoring'
import { getLessonBlocksContentWatcherSaga } from './lessons/blockInstances/getLessonBlocksContent.saga'
import { participantsGetWatcherSaga } from './participants/get.sagas'
import { createTaskWatcherSaga } from './blocks/task/createTaskBlock.saga.'
import { editTaskBlockWatcherSaga } from './blocks/task/editTaskBlock.saga'
import { destroyTaskBlockWatcherSaga } from './blocks/task/destroyTaskBlock.saga'
import { createMultimediaWatcherSaga } from './blocks/multimedia/createMultimediaBlock.saga'
import { editMultimediaBlockWatcherSaga } from './blocks/multimedia/editMultimediaBlock.saga'
import { destroyMultimediaBlockWatcherSaga } from './blocks/multimedia/destroyMultimediaBlock.saga'
import { participantsDownloadWatcherSaga } from './participants/download.saga'
import { participantGetCoursesWatcherSaga } from './participant/get.sagas'
import { participantEditProfileWatcherSaga } from './participant/edit.saga'
import { participantEditRoleWatcherSaga } from './participant/editRole.saga'
import { newMessageWatcherSaga } from './chat/create.saga'
import { getCourseMessagesWatcherSaga } from './chat/get.saga'
import { getConversationsListWatcherSaga } from './chat/getConversationsList.saga'
import { getConversationMessagesWatcherSaga } from './chat/getConversationMessages.saga'
import { getUnreadMessagesCountWatcherSaga } from './chat/getUnreadMessagesCount'
import { getCourseUnreadMessagesCountWatcherSaga } from './chat/getCourseUnreadMessagesCount'
import { deleteMessageWatcherSaga } from './chat/destroy.saga'
import { createEvaluationWatcherSaga } from './blocks/evaluation/createEvaluationBlock.saga'
import { editEvaluationBlockWatcherSaga } from './blocks/evaluation/editEvaluationBlock.saga'
import { destroyEvaluationBlockWatcherSaga } from './blocks/evaluation/destroyEvaluationBlock.saga'
import { createEvaluationLikertWatcherSaga } from './blocks/evaluation/questions/CreateLikert.saga'
import { editEvaluationLikertWatcherSaga } from './blocks/evaluation/questions/EditLikert.saga'
import { destroyEvaluationLikertWatcherSaga } from './blocks/evaluation/questions/DestroyLikert.saga'
import { evaluationBlockWatcherSaga } from './blocks/evaluation/getEvaluationBlock.saga'
import { sendEvaluationWatcherSaga } from './blocks/evaluation/sendEvaluation.saga'
import { courseResetWatcherSaga } from './participant/reset.saga'
import { profilesListWatcherSaga } from './lmsProfiles/geAllProfilestList'
import { getUserRoleWatcherSaga } from './participant/getRole.saga'
import { canCourseWatcherSaga } from './access/canCourse'
import { participantsAddProfilesWatcherSaga } from './participants/addProfilesBulkAction.sagas'
import { participantsRemoveProfilesWatcherSaga } from './participants/removeProfilesBulkAction.sagas'
import { inactiveParticipantsListWatcherSaga } from './participants/getInactiveParticipantList.sagas'
import { participantsSetActiveWatcherSaga } from './participants/setActiveParticipantsBulkAction.saga'
import { getAreasWatcherSaga } from './areas/Get'
import { participantIdsListWatcherSaga } from './participants/idsList.sagas'
import { foldersListWatcherSaga } from './folders/list.saga'
import { destroyFolderWatcherSaga } from './folders/destroy.saga'
import { createFolderWatcherSaga } from './folders/create.saga'
import { editFolderWatcherSaga } from './folders/edit.saga'
import { assignCourseFolderWatcherSaga } from './folders/assignCourse.saga'
import { orderFolderWatcherSaga } from './folders/order.saga'
import { getCourseFoldersListWatcherSaga } from './courses/getCoursesFolders'
import { getCourseAllFoldersListWatcherSaga } from './courses/getCoursesAllFolders'
import { certificateListWatcherSaga } from './certificates/list.saga'
import { createCertificateWatcherSaga } from './certificates/create.saga'
import { destroyCertificateWatcherSaga } from './certificates/destroy.saga'
import { editCertificateWatcherSaga } from './certificates/edit.saga'
import { certificateCourseListWatcherSaga } from './certificates/getCourses.saga'
import { getCertificateWatcherSaga } from './certificates/getCertificate.saga'
import { myCertificateListWatcherSaga } from './certificates/getMyCertificates.saga'
import { getMyCertificateWatcherSaga } from './certificates/getMyCertificate.saga'
import { createScormWatcherSaga } from './blocks/scorm/createScormBlock.saga'
import { destroyScormBlockWatcherSaga } from './blocks/scorm/destroyScormBlock.saga'
import { editScormBlockWatcherSaga } from './blocks/scorm/editMultimediaBlock.saga'
import { updateLessonContentBlockProgressWatcherSaga } from './lessons/blockInstances/updateLessonBlockContentProgress.saga'
import externalCourses from './externalCourses'
import externalCourseParticipants from './externalCourseParticipants'
import externalCourseCertificates from './externalCourseCertificates'
import externalCoursesEnrolled from './externalCoursesEnrolled'
import general from './general'
import meetingSagas from './blocks/meeting'

export default function* rootSaga() {
  yield all([
    hierarchyUploadWatcherSaga(),
    hierarchyListWatcherSaga(),
    ...user,
    lmsProfilesListWatcherSaga(),
    lmsProfilesCreateWatcherSaga(),
    lmsProfilesEditProfileWatcherSaga(),
    lmsProfilesDeleteProfileWatcherSaga(),
    lmsProfilesUploadWatcherSaga(),
    participantsListWatcherSaga(),
    participantsDestroyWatcherSaga(),
    enrolCreateWatcherSaga(),
    destroyLessonWatcherSaga(),
    editLessonOrderWatcherSaga(),
    editLessonWatcherSaga(),
    enrolListWatcherSaga(),
    enrolAdminListWatcherSaga(),
    enrolAdminEditWatcherSaga(),
    editEnrolWatcherSaga(),
    editSynchronousCourseEnrolWatcherSaga(),
    enrolCreateManuallyWatcherSaga(),
    getLessonWatcherSaga(),
    getNextLessonWatcherSaga(),
    answerLikertCreateWatcherSaga(),
    answerLikertEditWatcherSaga(),
    answerOpenEnderCreateWatcherSaga(),
    answerTaskCreateWatcherSaga(),
    questionTypesListWatcherSaga(),
    blockListWatcherSaga(),
    createLessonWatcherSaga(),
    getLessonWatcherSaga(),
    createSurveyWatcherSaga(),
    destroySurveyWatcherSaga(),
    editBlockSurveyWatcherSaga(),
    destroyTaskAnswerWatcherSaga(),
    createLikertWatcherSaga(),
    questionListWatcherSaga(),
    createOpenEndedtWatcherSaga(),
    getLmsLessonWatcherSaga(),
    questionGetWatcherSaga(),
    questionDestroyLikertWatcherSaga(),
    questionDestroyOpenEndedWatcherSaga(),
    createRichTextWatcherSaga(),
    editRichTextBlockWatcherSaga(),
    destroyRichTextWatcherSaga(),
    editLikertWatcherSaga(),
    editOpenEndedWatcherSaga(),
    editBlocksOrderWatcherSaga(),
    ...monitoring,
    getLessonBlocksContentWatcherSaga(),
    participantsGetWatcherSaga(),
    createTaskWatcherSaga(),
    editTaskBlockWatcherSaga(),
    destroyTaskBlockWatcherSaga(),
    createMultimediaWatcherSaga(),
    editMultimediaBlockWatcherSaga(),
    destroyMultimediaBlockWatcherSaga(),
    participantsDownloadWatcherSaga(),
    participantGetCoursesWatcherSaga(),
    participantEditProfileWatcherSaga(),
    participantEditRoleWatcherSaga(),
    newMessageWatcherSaga(),
    getCourseMessagesWatcherSaga(),
    getConversationsListWatcherSaga(),
    getConversationMessagesWatcherSaga(),
    getUnreadMessagesCountWatcherSaga(),
    getCourseUnreadMessagesCountWatcherSaga(),
    deleteMessageWatcherSaga(),
    createEvaluationWatcherSaga(),
    editEvaluationBlockWatcherSaga(),
    destroyEvaluationBlockWatcherSaga(),
    createEvaluationLikertWatcherSaga(),
    editEvaluationLikertWatcherSaga(),
    destroyEvaluationLikertWatcherSaga(),
    evaluationBlockWatcherSaga(),
    sendEvaluationWatcherSaga(),
    courseResetWatcherSaga(),
    profilesListWatcherSaga(),
    getUserRoleWatcherSaga(),
    canCourseWatcherSaga(),
    participantsAddProfilesWatcherSaga(),
    participantsRemoveProfilesWatcherSaga(),
    inactiveParticipantsListWatcherSaga(),
    participantsSetActiveWatcherSaga(),
    getAreasWatcherSaga(),
    foldersListWatcherSaga(),
    destroyFolderWatcherSaga(),
    createFolderWatcherSaga(),
    editFolderWatcherSaga(),
    assignCourseFolderWatcherSaga(),
    getCourseFoldersListWatcherSaga(),
    getCourseAllFoldersListWatcherSaga(),
    orderFolderWatcherSaga(),
    participantIdsListWatcherSaga(),
    certificateListWatcherSaga(),
    createCertificateWatcherSaga(),
    destroyCertificateWatcherSaga(),
    editCertificateWatcherSaga(),
    certificateCourseListWatcherSaga(),
    getCertificateWatcherSaga(),
    myCertificateListWatcherSaga(),
    getMyCertificateWatcherSaga(),
    createScormWatcherSaga(),
    destroyScormBlockWatcherSaga(),
    editScormBlockWatcherSaga(),
    updateLessonContentBlockProgressWatcherSaga(),
    ...courses,
    ...externalCourses,
    ...externalCourseParticipants,
    ...externalCoursesEnrolled,
    ...externalCourseCertificates,
    ...general,
    ...meetingSagas,
  ])
}
